module.exports = __webpack_public_path__ + "static/SuperHealthpharmacy-cb923e3ff82a13b17faac59eb15333bd.jpg";